import { render, staticRenderFns } from "./TransportForm.vue?vue&type=template&id=b5c70f02&scoped=true&"
import script from "./TransportForm.vue?vue&type=script&lang=js&"
export * from "./TransportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c70f02",
  null
  
)

export default component.exports